import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faInstagram, faLinkedin, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone, faHome, faPrint, faGem } from "@fortawesome/free-solid-svg-icons";
import "./footer.css"; // Import the CSS file

const Footer = () => {
  return (
    <footer className="footer">
      {/* Social Media Section */}
      <div className="social-section">
        <span>Get connected with us on social networks:</span>
        <div className="social-icons">
          <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a href="https://sriammansweets.com/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faGoogle} />
          </a>
          <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://in.linkedin.com/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
        </div>
      </div>

      {/* Footer Content */}
      <div className="footer-content">
        <div className="footer-section">
          <h6><FontAwesomeIcon icon={faGem} className="icon" /> SriAmmanSweets</h6>
          <p>
            Bring home a celebration
            <br />
            A story that began in 2004 is now a beloved and trusted name in homes across Tamil Nadu with more than 30 outlets and counting.
          </p>
        </div>

        <div className="footer-section">
          <h6>Useful Links</h6>
          <ul>
            <li><Link to="/privacypolicy">Privacy Policy</Link></li>
            <li><Link to="/refundpolicy">Refund Policy</Link></li>
            <li><Link to="/termsandcondition">Terms and Conditions</Link></li>
            <li><Link to="/Customer">Customer Support</Link></li>
          </ul>
        </div> 

        <div className="footer-section">
          <h6>Contact</h6>
          <p><FontAwesomeIcon icon={faHome} /> Sri Amman Sweets, Sathya Nagar, Gopalapuram, P.N.Palayam(T.K), Salem Dt-636938</p>
          <p><FontAwesomeIcon icon={faEnvelope} /> sriammansweets@gmail.com</p>
          <p><FontAwesomeIcon icon={faPhone} /> +91 7010490133</p>
          <p><FontAwesomeIcon icon={faPrint} /> +91 8637491264</p>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        © 2025 Copyright:
        <a href="https://www.brightechsoftware.com/" target="_blank" rel="noopener noreferrer"> @BRIGHTECH SOFTWARE</a>
      </div>
    </footer>
  );
};

export default Footer;
